@import '~style-sheet-helpers/core.less';
@import (reference) '../modals/order-details-modal/order-details-modal-content/order-summary-and-customer-recipient/style.module.less';
@import (reference) '../modals/order-details-modal/order-details-modal-content/order-details-modal-content.module.less';
@import '../../app-brand/entities/entity-layer.module.less';
@import '../../constants/spacing.module.less';

.customer-widget-wrapper {
  display: flex;
  flex-direction: column;
  flex: 1;
  width: 100%;
  position: relative;
}

.top-row {
  display: flex;
  align-items: center;
  @order-summary-and-customer-recipient-title-text();
}

.no-header-top-row {
  position: absolute;
  right: 5px;
  top: -5px;
}

.ship-to {
  position: relative;

  > div {
    display: flex;
  }
}

.shipto-label,
.edit-shipto-label {
  line-height: 12px;
  margin-bottom: 3px;
  padding-right: 15px;
  @order-summary-and-customer-recipient-label-text();
}

.icon {
  @icon();
  height: 20px;
  width: 20px;
  margin-right: 8px;
}

.edit-shipto-label {
  position: absolute;
}

// <EditShipToLink />
.information-icon {
  margin: 0 5px 0 0;
  > svg {
    transform: scale(0.5);
    height: 25px;
    width: 25px;
  }
}

.edit-link-button {
  @od-action-buttons-font-size();
  padding: @space-8 0 @space-8 @space-8;
}

.edit-link-sidebar {
  position: relative;
  top: -5px;
  z-index: 1;
}

// <ShipToContainer />
.shipto-address-wrapper {
  @order-summary-and-customer-recipient-value-text();
}

.edit-shipto-address {
  margin-top: 0;
  > label {
    @order-summary-and-customer-recipient-edit-state-label-text();
  }
  input,
  select,
  div[class*='native-dropdown'] {
    border-color: @customer-recipient--ship-to--border-color;
    &:focus-within {
      border-color: @customer-recipient--ship-to--focus--border-color;
    }
  }
}

// < Sold To />
.sold-to {
  margin-top: 15px;
  display: flex;
  padding-bottom: 15px;
  color: @customer-recipient--sold-to--text-color;
}

.labeled-info {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex: 1;
  min-width: 0;
}

.labeled-info-content {
  width: 100%;
}

.flex {
  display: flex;
  align-items: center;
  text-overflow: ellipsis;
  overflow: hidden;
  svg {
    transform: scale(0.55);
  }
}

.fill {
  fill: @customer-recipient--default--fill-color;
  width: 20px;
  min-width: 20px;
  height: 20px;
}

.line-content {
  @order-summary-and-customer-recipient-value-text();
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.tooltip-header {
  font-weight: 700;
  margin: 5px 0 10px;
  width: 270px;
}

.pickupRelayTooltipWrapper {
  display: flex;
}
